import * as React from "react";

export const ImagePartIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width={56} height={39} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m44.496 38.225 3.37-.033h3a5 5 0 0 0 5-5v-27.5a5 5 0 0 0-5-5h-45.5a5 5 0 0 0-5 5v27.5a5 5 0 0 0 5 5h30l9.13.033Z"
      fill="#D9D9D9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.212 10.65a2 2 0 0 0-3.203 0l-8.777 11.73-3.891-5.2a2 2 0 0 0-3.203 0L8.67 27.158c-.987 1.318-.046 3.198 1.601 3.198h14.934c.048 0 .096-.002.143-.005h20.61c1.647 0 2.588-1.88 1.601-3.198L35.212 10.65Z"
      fill="#F6F6F6"
    />
    <circle cx={20.557} cy={11.192} r={2.71} fill="#F6F6F6" />
  </svg>
);
